import { Alert, Grid, Skeleton } from '@mui/material';

import { useServiceHealth } from '@/hooks/useServiceHealth';
import { ServiceHealthCard } from './ServiceHealthCard';

export function ServiceHealthCards() {
  const { data, isLoading, error } = useServiceHealth();

  if (isLoading) {
    return (
      <Grid container spacing={2}>
        {[0, 1, 2].map((i) => (
          <Grid key={i} item xs={12} sm={6} md={4} lg={3}>
            <Skeleton variant="rectangular" height={140} sx={{ borderRadius: 1 }} />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (error) {
    return (
      <Alert severity="warning" sx={{ mb: 0 }}>
        Could not load service health: {error.message}
      </Alert>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Alert severity="info">
        No services reporting yet — service health populates after the first Datadog sync.
      </Alert>
    );
  }

  return (
    <Grid container spacing={2}>
      {data.map((h) => (
        <Grid key={h.service} item xs={12} sm={6} md={4} lg={3}>
          <ServiceHealthCard health={h} />
        </Grid>
      ))}
    </Grid>
  );
}
